module.exports = __webpack_public_path__ + "img/62.2.TN.febbd40a.png";